<template lang="pug">
f-login-sumut(v-if="profile === 'SUMUT'")
f-login-bengkulu(v-else-if="profile === 'BENGKULU'")
f-login-sulteng(v-else-if="profile === 'SULTENG'")
f-login-sulut(v-else-if="profile === 'SULUT'")
f-login-default(v-else)
</template>

<script>
import config from "../../config";

export default {
  name: "FLogin",
  data() {
    return {
      profile: config.profile,
    };
  },
  created() {
    document.title = config.name;
    const link = document.querySelector("[rel='icon']");
    link.setAttribute("href", config.favicon);
  },
};
</script>